export {default as Routes} from './Routes';



// WEBPACK FOOTER //
// ./src/components/Routes/index.tsx